import React from "react";
import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class IoiInspections extends CollectionOverride {
	constructor(props) {
		super(props, Types.Products_Ioi_Inspections._name);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 160,
				Cell: (props) => {
					return (
						<span>
							<Link to={`/products/ioi_inspections/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/>View Inspection</Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Inspector",
				accessor: "inspector",
			},
			{
				Header: "Start",
				id: "date_start",
				width: 160,
				/** @param {Products_Ioi_Inspections_Object} obj*/
				accessor: obj => {
					return moment(obj.date_start)
						.local()
						.format("MM/DD/YYYY")
				}
			},
			{
				Header: "End",
				id: "date_end",
				width: 160,
				/** @param {Products_Ioi_Inspections_Object} obj*/
				accessor: obj => {
					return obj.date_end ? moment(obj.date_end)
						.local()
						.format("MM/DD/YYYY") : ''
				}
			},
			{
				Header: "Creator",
				id: "creator",
				/** @param {Products_Ioi_Inspections_Object} obj*/
				accessor: obj => {
					return obj.creator ? obj.creator : 'Owner'
				}

			},
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('IOI Inspections', "")}
								{this.renderHeaderRight("Ioi Inspections", columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
